import { render } from "./editFriendly.vue?vue&type=template&id=0eef7a7e"
import script from "./editFriendly.vue?vue&type=script&lang=js"
export * from "./editFriendly.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__